export const iconFontAwesomeSecurityUserLock = (
	<i className="fa-solid fa-user-lock"></i>
);
